












































import { computed, defineComponent, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString, getMainCurrencyCode } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import ModalView from "@/components/ModalView";
import { FollowersMap } from "../../types";

export default defineComponent({
  name: "FollowButtonController",
  components: { BaseButton, BaseConfirm, ModalView },
  props: {
    authUserId: { type: String, required: true },
    isFollowingPage: { type: Boolean, required: true },
    authorFollowings: { type: Object as () => FollowersMap, required: true },
    isAuthor: { type: Boolean, required: true },
    followerData: { type: Object as () => UserPublicData | null },
  },
  setup(props) {
    const isFollowed = ref<boolean>(false);
    const showUnfollowConfirm = ref<boolean>(false);
    const subscribeAmount = ref<number>(0);
    const isDisabledUnfollowId = computed(() => props.followerData?.id === "1");

    if (props.isFollowingPage && props.isAuthor) {
      isFollowed.value = true;
    }

    const canFollowing = computed(() => {
      const followerId = props.followerData?.id || "-1";
      return !props.authorFollowings?.[followerId] && !props.followerData?.disabled;
    });

    const showFollow = computed(
      () => props.followerData !== null && canFollowing.value && props.followerData?.id !== props.authUserId
    );

    const confirmDescription = computed(() => {
      if (!subscribeAmount.value) return "";
      return $t("You unfollowed {screenName} but still have an active subscription for {amount}", {
        amount: formatMoneyString(subscribeAmount.value, { currencyCode: getMainCurrencyCode() }),
        screenName: props.followerData?.screenName ?? "",
      });
    });

    const getSubscriptionData = async () => {
      return await providers.SubscriptionProvider.search({
        data: { consumerIds: [props.authUserId], providerId: props.followerData?.id },
      });
    };

    const toggleFollow = async () => {
      if (props.followerData) {
        isFollowed.value = await providers.FollowingsProvider.toggle({ id: props.followerData.id });
      }
    };

    const onToggleFollow = async () => {
      if (isFollowed.value) {
        const subscription = await getSubscriptionData();
        if (subscription.result.length) {
          subscribeAmount.value = subscription.result.reduce((acc, curr) =>
            acc.amount > curr.amount ? acc : curr
          ).amount;
          showUnfollowConfirm.value = true;
        }
      }
      await toggleFollow();
    };

    const closeUnfollowConfirm = () => {
      showUnfollowConfirm.value = false;
    };

    return {
      isFollowed,
      showFollow,
      canFollowing,
      onToggleFollow,
      isDisabledUnfollowId,
      showUnfollowConfirm,
      subscribeAmount,
      confirmDescription,
      closeUnfollowConfirm,
    };
  },
});
